import { Button } from "@mui/material";
import React from "react";

interface ProductCategoryButtonProps {
  item: string;
  selectedCategory: string;
  handleCategorySelect: (category: string | null) => void;
}

const ProductCategoryButton: React.FC<ProductCategoryButtonProps> = ({
  item,
  selectedCategory,
  handleCategorySelect,
}) => {
  return (
    <div className="col-12 col-md-3 col-xl-2">
      <Button
        fullWidth
        variant={selectedCategory === item ? "contained" : "outlined"}
        onClick={() => handleCategorySelect(item)}
        sx={{
          height: "56px",
          textTransform: "none",
          fontWeight: 500,
          letterSpacing: "normal",
          fontSize: "0.9375rem",
          "&.MuiButton-outlined": {
            borderColor: "primary.main",
            "&:hover": {
              backgroundColor: "primary.light",
              borderColor: "primary.dark",
            },
          },
          "&.MuiButton-contained": {
            "&:hover": {
              backgroundColor: "primary.dark",
            },
          },
        }}
        className="px-2 rounded-3 text-capitalize"
      >
        {item}
      </Button>
    </div>
  );
};

export default ProductCategoryButton;
